import store from '@/app/app-state';
import { removeEmptyValues } from '@/helpers/object';
import { getMaxSalaryValue, getMinSalaryValue } from '@/helpers/salary';
import { escapeHtml } from '@/helpers/string';

export const getDefaultFilters = () => {
  const country = store.getters['country/currentCountry'];

  return {
    country,
  };
};

/* eslint-disable @typescript-eslint/camelcase */
export const filtersToJobSearchRawParams = ({
  city,
  country,
  keywords,
  professions = [],
  salary,
  careerLevels = [],
}) => {
  const rawParams = {
    location: city,
    location_country: country?.value,
    keywords,
    filter_by_channels: professions
      ?.flatMap((profession) => profession.options)
      .map((channel) => channel.value)
      .join(','),
    minSalary: salary && salary[0].value,
    maxSalary: salary && salary[1].value,
    filter_by_careerLevels: careerLevels?.map((careerLevel) => careerLevel.value).join(','),
  };

  return removeEmptyValues(rawParams);
};
/* eslint-enable @typescript-eslint/camelcase */

export const getDefaultRawDataValues = (requestedCountry) => {
  const country = store.getters['country/getCountryByCountryValue'](requestedCountry);
  const salaryOptions = store.getters['salary/getSalaryOptions'](country.value);

  /* eslint-disable @typescript-eslint/camelcase */
  return {
    channels: '',
    headhunterName: '',
    locationCountry: country.value,
    locationRadius: 0,
    minSalary: salaryOptions[0].value,
    maxSalary: salaryOptions[salaryOptions.length - 1].value,
    location: '',
    filterByCareerLevels: '',
    startIndex: 0,
    limit: 25,
    firstUserSearch: 1,
  };
  /* eslint-enable @typescript-eslint/camelcase */
};

export const filtersToSearchRawParams = ({
  city,
  country,
  mainSalary,
  salary,
  professions = [],
  headhunterName,
  careerLevels = [],
  startIndex,
}) => {
  /* eslint-disable @typescript-eslint/camelcase */
  const defaultValues = getDefaultRawDataValues(country?.value || country);

  return {
    ...defaultValues,
    channels: professions
      ?.flatMap((profession) => profession.options)
      .map((channel) => channel.value)
      .join(','),
    minSalary: getMinSalaryValue({
      salary,
      mainSalary,
      defaultValue: defaultValues.minSalary,
    }),
    maxSalary: getMaxSalaryValue({
      salary,
      mainSalary,
      defaultValue: defaultValues.maxSalary,
    }),
    location: city || '',
    headhunterName: headhunterName || '',
    filterByCareerLevels: careerLevels?.map((careerLevel) => careerLevel.value).join(',') || '',
    startIndex: startIndex || 0,
  };
  /* eslint-enable @typescript-eslint/camelcase */
};

export const encodeExposedFilterParams = (filters = {}) => ({
  ...filters,
  headhunterName: filters.headhunterName ? escapeHtml(filters.headhunterName) : '',
  city: filters.city ? escapeHtml(filters.city) : '',
});
